import { Component, Input } from '@angular/core';
import { CardDesignComponent } from '../card-design.component';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-card3',
  templateUrl: './card3.component.html',
  styleUrls: ['./card3.component.scss'],
  standalone: false
})
export class Card3Component {
  image: any;
  @Input() isSelected: boolean = false;

  defaultImage: string = 'https://aieventzo.com/upload/event_logo/66a0e18c3d4d9.png'; // Fallback image URL

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.defaultImage; // Set the fallback image URL
  }

  constructor(
    private imageService: ServicesService
  ) { }

  ngOnInit() {
    this.imageService.image$.subscribe((image) => {
      this.image = 'https://aieventzo.com/upload/event_image/' + image;
      console.log('Card3 image', image);
    });

  }



}
